var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtlassian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_536_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6905 29.8804C18.3991 29.4999 17.9688 29.2504 17.4938 29.1864C17.0189 29.1224 16.5379 29.2492 16.1562 29.539C15.9317 29.7161 15.7505 29.9421 15.6266 30.1999L0.0667046 61.3285C-0.153677 61.7696 -0.189875 62.2802 -0.0339342 62.748C0.122007 63.2159 0.457326 63.6026 0.898318 63.8233C1.15609 63.9537 1.44106 64.0212 1.72993 64.0203H23.4088C23.756 64.0292 24.0983 63.9366 24.3937 63.7539C24.6891 63.5712 24.9248 63.3063 25.072 62.9917C29.7509 53.3275 26.9147 38.6342 18.6905 29.8804Z",
    fill: "url(#paint0_linear_536_13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1273 1.55281C26.2484 7.52182 23.9878 14.3967 23.5673 21.5029C23.1468 28.6091 24.5809 35.7026 27.7288 42.0874L38.1809 62.9915C38.3353 63.3005 38.5726 63.5603 38.8664 63.742C39.1602 63.9237 39.4987 64.02 39.8441 64.0201H61.5186C61.763 64.0207 62.0051 63.973 62.2311 63.8797C62.457 63.7864 62.6623 63.6494 62.8352 63.4766C63.008 63.3037 63.145 63.0984 63.2383 62.8725C63.3316 62.6465 63.3793 62.4044 63.3787 62.1599C63.3789 61.8716 63.313 61.5871 63.1862 61.3283L33.2918 1.54406C33.15 1.24448 32.9259 0.991349 32.6458 0.814088C32.3657 0.636827 32.0411 0.542725 31.7096 0.542725C31.3781 0.542725 31.0535 0.636827 30.7734 0.814088C30.4933 0.991349 30.2692 1.24448 30.1273 1.54406V1.55281Z",
    fill: "#2684FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_13",
    x1: 27.2561,
    y1: 34.6381,
    x2: 10.8252,
    y2: 63.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_536_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlassian);
export default __webpack_public_path__ + "static/media/Atlassian.f2a9749a7de0fe6746dd74fb3537cfae.svg";
export { ForwardRef as ReactComponent };